import { gql } from '@apollo/client'

export const GET_SENDABLE_COUNTRIES = gql`
  query GetSendableCountries {
    sendableCountries {
      id
      name
      flagImgURL
      iconFlagImgURL
      currency
      currencySymbol
      callingCode
      isoCode
      totalDigits
      supportNumber
      exchangeRate {
        id
        date
        rate
      }
    }
  }
`
export const GET_COUNTRIES = gql`
  query getCountries {
    getCountries {
      id
      name
      callingCode
      iconFlagImgURL
      totalDigits
    }
  }
`
export const GET_STATES = gql`
  query GetSates($countryId: ID!) {
    states(countryId: $countryId) {
      id
      countryId
      name
    }
  }
`

export const SELECT_COUNTRY = gql`
  mutation SelectCountry($country: String!) {
    selectCountry(country: $country) @client
  }
`

export const GET_SELECTED_COUNTRY = gql`
  query SelectedCountry {
    selectedCountry @client
  }
`

export const GET_SELECTED_COUNTRY_AND_STATE = gql`
  query SelectedCountryAndState {
    selectedCountry @client
    selectedState @client
  }
`

export const GET_SELECTED_COUNTRY_STATE_AND_CONTACT = gql`
  query SelectedCountryStateAndContact {
    selectedCountry @client
    selectedState @client
    selectedContact @client
  }
`

export const SELECT_STATE = gql`
  mutation SelectState($state: String!) {
    selectState(state: $state) @client
  }
`

export const GET_SELECTED_STATE = gql`
  query SelectedState {
    selectedState @client
  }
`
export const GET_AUTH_COUNTRIES = gql`
  query GetAuthCountriesPushMoney {
    authCountriesPushMoney {
      id
      name
      flagImgURL
      bannerImgURL
      bannerMobileImgURL
      iconFlagImgURL
      currency
      currencySymbol
      callingCode
      isoCode
      totalDigits
    }
  }
`

export const GET_AUTH_COUNTRIES_STORAGE = gql`
  query CountrySelectedInfo {
    countrySelectedInfo @client
  }
`
